import { cmsService, dssService } from '../service';

export default {
  // 报装码验证
  postActiveCode(installCode, timeout = 2000) {
    let p1 = new Promise((resolve, reject) => {
      const timeout = {
        code: 200,
        result: 'timeout'
      };
      setTimeout(() => {
        resolve(timeout);
      }, 30000);
    });

    let p2 = new Promise((resolve, reject) => {
      const success = {
        code: 200,
        result: 'success',
        data: []
      };
      const fail = {
        code: 200,
        result: 'fail',
        data: []
      };
      cmsService.getSnInfo(installCode).then(res => {
        const {
          data
        } = res;
        if (data) {
          const result = dataAnalysis(data);
          success.data = result;
          success.resData = data;
          resolve(success);
        } else {
          resolve(fail);
        }
      });
    });

    return Promise.race([p1, p2]);
  },
  // 获取激活状态
  getActiveStatus(sn, timeout = 2000) {
    let p1 = new Promise((resolve, reject) => {
      const timeout = {
        code: 200,
        result: 'timeout'
      };
      setTimeout(() => {
        resolve(timeout);
      }, 30000);
    });

    let p2 = new Promise((resolve, reject) => {
      const success = {
        code: 200,
        result: 'success',
        data: null
      };
      const fail = {
        code: 200,
        result: 'fail',
        data: null
      };
      dssService.getActiveStatus({sn}).then(res => {
        const {
          data
        } = res;
        if (data.isActivate) {
          success.data = data;
          resolve(success);
        } else {
          // resolve(fail);
          reject(fail);
        }
      });
    });
    return Promise.race([p1, p2]);
  },
  // 获取激活码
  getActiveCode(type, code, pcsn, token, data, originData, baseParam, extra, timeout = 2000) {
    // 超时时间
    let p1 = new Promise((resolve, reject) => {
      const timeout = {
        code: 200,
        result: 'timeout'
      };
      setTimeout(() => {
        resolve(timeout);
      }, 30000);
    });

    let p2 = new Promise((resolve, reject) => {
      const success = {
        code: 43215678,
        result: 'success'
      };

      let deviceInfo = {
        baseParam,
        sn: code,
        pcsn: pcsn,
        orgName: data.company,
        provinceName: data.districtArr[0],
        cityName: data.districtArr[1],
        districtName: data.districtArr[2],
        address: data.street,
        extra: extra,
      };

      if (type === 'reportCode') {
        // 表单修改
        const middleData = reverseConversion(data);
        const finalData = {
          ...originData,
          ...middleData
        };
        // 上报客户信息到 it 系统
        let task1 = new Promise((resolve, reject) => {
          cmsService.putClientInfo(code, token, finalData).then(res => {
            resolve(res);
          });
        });
        // 根据设备信息 sn、pcsn 获取设备激活码
        let task2 = new Promise((resolve, reject) => {
          dssService.getActivationCode(deviceInfo).then(res => {
            resolve(res);
          });
        });
        Promise.all([task1, task2]).then((values) => {
          success.code = values[1].data;
          resolve(success);
        });
      } else {
        // 提交新表单
        const finalData = reverseConversion(data);
        // 上报客户信息到 it 系统
        let task1 = new Promise((resolve, reject) => {
          cmsService.postClientInfo(code, token, finalData).then(res => {
            resolve(res);
          });
        });
        // 根据设备信息 sn、pcsn 获取设备激活码
        let task2 = new Promise((resolve, reject) => {
          dssService.getActivationCode(deviceInfo).then(res => {
            resolve(res);
          });
        });
        Promise.all([task1, task2]).then((values) => {
          success.code = values[1].data;
          resolve(success);
        });
      }
    });
    return Promise.race([p1, p2]);
  },
  // 根据 sn 查询大板激活码
  getSnActiveCode(deviceInfo) {
    return new Promise((resolve, reject) => {
      dssService.getActivationCode(deviceInfo).then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
    });
  },
  // 根据 sn 获取激活信息
  getActiveInfo(sn) {
    return new Promise((resolve, reject) => {
      dssService.getActiveInfo({sn}).then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
    });
  },
  // 查询公司信息
  getComanyInfo(word) {
    // 超时时间
    let p1 = new Promise((resolve, reject) => {
      const timeout = {
        code: 200,
        result: 'timeout'
      };
      setTimeout(() => {
        resolve(timeout);
      }, 30000);
    });

    let p2 = new Promise((resolve, reject) => {
      const success = {
        code: 200,
        result: 'success',
        data: []
      };
      const fail = {
        code: 200,
        result: 'fail',
        data: []
      };
      cmsService.getCompanyList(word).then(res => {
        const {
          data
        } = res;
        if (data) {
          success.data = data;
          resolve(success);
        } else {
          resolve(fail);
        }
      });
    });
    return Promise.race([p1, p2]);
  }
};

function dataAnalysis(data) {
  const {
    purchaseChannelType,
    finalCusName,
    contactName,
    contactPhone,
    province,
    city,
    state,
    address
  } = data;
  let phoneStr = '';
  if (contactPhone && contactPhone !== null) {
    phoneStr = contactPhone.substring(0, 3) + ' ' + contactPhone.substring(3, 7) + ' ' + contactPhone.substring(7);
  }
  return {
    dealer: purchaseChannelType || '',
    company: finalCusName,
    contactPerson: contactName,
    telephone: phoneStr,
    districtArr: [province, city, state],
    street: address
  };
}

function reverseConversion(data) {
  const {
    dealer,
    company,
    contactPerson,
    telephone,
    districtArr,
    street
  } = data;
  return {
    purchaseChannelType: dealer,
    finalCusName: company,
    contactName: contactPerson,
    contactPhone: telephone.replace(/\s/g, ''),
    province: districtArr[0],
    city: districtArr[1],
    state: districtArr[2],
    address: street
  };
}



// WEBPACK FOOTER //
// ./src/model/index.js